import { resumeDataSchema } from "@reactive-resume/schema";
import { createZodDto } from "nestjs-zod/dto";
import { z } from "zod";

export const printResumeSchema = z.object({ data: resumeDataSchema });
export class PrintResumeDto extends createZodDto(printResumeSchema) {}
